module.exports = __webpack_public_path__ + "img/charles yates old.5842735b.jpg";